import { render, staticRenderFns } from "./ConfirmAdditionalChargesModal.vue?vue&type=template&id=83f62a90&"
import script from "./ConfirmAdditionalChargesModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmAdditionalChargesModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAdditionalChargesModal.vue?vue&type=style&index=0&id=83f62a90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports